import Modal from "components/UI/organisms/Modal"
import { useUI } from "providers/UIProvider"

import { Container, Box, Flex, Text, Center } from "@chakra-ui/react"

import Icon from "components/UI/atoms/Icon"
import Button from "components/UI/atoms/Button"
import { UI_INITIAL_STATE } from "providers/UIProvider/UIProviderConstants"
import { useSettings } from "providers/SettingsProvider/SettingsProvider"

export interface IHistoryData {
  id: number
  logoUrl: string
  address: string
  currentValues: number[]
  currentLabel: string
  newLabel: string
  newValues: number[]
  currentCommissionType?: number
  newCommissionType?: number
}

const FeeHistoryModal = () => {

  const { modals, toggleModal, T } = useUI()
  const { changeLaundryCancelCommissionsLoading, changeLaundryCommissionLoading, changeLaundryScheduleIntervalLoading } = useSettings()
  const data = modals.feeHistoryModal?.data?.data || [] as IHistoryData[]
  const handleDeny = modals.feeHistoryModal?.data?.handleDeny
  const handleSubmit = modals.feeHistoryModal?.data?.handleSubmit

  const handleDenyClick = () => {
    toggleModal("feeHistoryModal", false, UI_INITIAL_STATE.modals.feeHistoryModal.data)
    if (handleDeny) {
      handleDeny()
    }
  }


  const renderIcon = (commissionType: number | undefined) => {
    if (commissionType !== undefined) {
      return commissionType === 1 ? "%" : "₾"
    }

    return "";
  }

  return (
    <Modal
      isOpen={modals.feeHistoryModal.isOpened}
      onClose={handleDenyClick}
      title={T("fee_history.title")}
      styles={{
        headerPadding: "20px 15px 20px 23px",
        width: "640px",
        bodyPadding: "0px 0px 0px 0px",
      }}
    >
      <Container padding="16px" width="100%" maxWidth="100%" maxH="80vh" overflowY="scroll">
        {data.map((item: IHistoryData) => (
          <Box key={item.id} mb="16px" bg="input_border_color_primary" padding="15px" borderRadius="base">
            <Flex alignItems="center" justifyContent="space-between">
              <Box mr="40px" flex="2">
                <Flex alignItems="center">
                  <img src={item.logoUrl} width="45px" />
                  <Text fontStyle="bold" fontSize="base" ml="15px">{item.address}</Text>
                </Flex>
              </Box>
              <Box>
                <Flex alignItems="flex-start">
                  <Flex flexDirection="column" alignItems="center" mr="30px">
                    <Text fontSize="xs" mb="5px">{item.currentLabel}</Text>
                    {item.currentValues.map((currentValue, i: number) => (
                      <Center
                        key={currentValue}
                        fontStyle="bold"
                        as="span"
                        w="36px"
                        h="22px"
                        bg="white"
                        fontSize="base"
                        borderRadius="100px"
                        mb={i === item.currentValues.length - 1 ? "" : "5px"}
                      >
                        {currentValue}{renderIcon(item.currentCommissionType)}
                      </Center>
                    ))}
                  </Flex>
                  <Flex flexDirection="column" alignItems="center">
                    <Text fontSize="xs" mb="5px">{item.newLabel}</Text>
                    {item.newValues.map((newValue, i: number) => (
                      <Center
                        key={newValue}
                        fontStyle="bold"
                        as="span"
                        w="36px"
                        h="22px"
                        bg="white"
                        fontSize="base"
                        borderRadius="100px"
                        color="primary"
                        mb={i === item.newValues.length - 1 ? "" : "5px"}
                      >
                        {newValue}{renderIcon(item.newCommissionType)}
                      </Center>
                    ))}
                  </Flex>
                </Flex>
              </Box>
              <Center ml="25px" as="button" w="28px" h="28px" bg="white" borderRadius="8px">
                <Icon name="close" iconStyles={{ width: "16px", height: "16px", fill: "button_grey_bg" }} />
              </Center>
            </Flex>
          </Box>
        ))}
        <Flex as="footer" w="100%" justifyContent="center" mt="30px">
          <Button
            text="დადასტურება"
            onClick={handleSubmit}
            variant="success"
            styles={{ width: "220px", height: "63px", fontSize: "18px" }}
            _hover={{ backgroundColor: "#08BA36" }}
            isLoading={changeLaundryCancelCommissionsLoading || changeLaundryCommissionLoading || changeLaundryScheduleIntervalLoading}
            isDisabled={changeLaundryCancelCommissionsLoading || changeLaundryCommissionLoading || changeLaundryScheduleIntervalLoading}
            leftIcon={
              <Icon
                name="confirm"
                iconStyles={{
                  width: "34px",
                  height: "34px",
                  fill: "white",
                }}
              />
            }
          />
          <Box ml="30px">
            <Button
              text="უარყოფა"
              onClick={handleDenyClick}
              variant="error"
              styles={{ width: "220px", height: "63px", fontSize: "18px" }}
              _hover={{ backgroundColor: "#F30028" }}
              isDisabled={changeLaundryCancelCommissionsLoading || changeLaundryCommissionLoading || changeLaundryScheduleIntervalLoading}
              leftIcon={
                <Icon
                  name="close_rounded"
                  iconStyles={{
                    width: "34px",
                    height: "34px",
                    fill: "white",
                  }}
                />
              }
            />
          </Box>
        </Flex>
      </Container>
    </Modal>
  )
}

export default FeeHistoryModal